import React, { createContext, useContext, useState, useEffect } from 'react';
import waveAuth from '../services/wave/waveAuth';

const WaveAuthContext = createContext(null);

export const WaveAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('WaveAuthProvider - Checking initial auth state');
    const checkAuth = () => {
      const isAuth = waveAuth.isAuthenticated();
      console.log('WaveAuthProvider - Initial auth state:', isAuth);
      setIsAuthenticated(isAuth);
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const value = {
    isAuthenticated,
    isLoading,
    setIsAuthenticated,
    setIsLoading
  };

  return (
    <WaveAuthContext.Provider value={value}>
      {children}
    </WaveAuthContext.Provider>
  );
};

export const useWaveAuth = () => {
  const context = useContext(WaveAuthContext);
  if (!context) {
    throw new Error('useWaveAuth must be used within a WaveAuthProvider');
  }
  return context;
}; 